import { render, staticRenderFns } from "./FareGroupView.vue?vue&type=template&id=4dce0410&"
import script from "./FareGroupView.vue?vue&type=script&lang=js&"
export * from "./FareGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports